import { Navigate, Route, Routes, useParams } from "react-router-dom"
import LandingPage from "./Views/LandingPage/LandingPage"
import AdministratorPage from "./Views/AdministratorPage/AdministratorPage"
import SchoolAdministratorPage from "./Views/SchoolAdministratorPage/SchoolAdministratorPage"
import UserPage from "./Views/UserPage/UserPage"
import LoginPage from "./Views/LoginPage/LoginPage"
import ProtectedRoute from "./Others/ProtectedRoute/ProtectedRoute"
import { AppArea, GetHomePath } from "./Helpers/RouteHelpers"
import "./index.css"


// Users may still have the old Spanish URLs saved as bookmarks or home screen shortcuts.
function RedirectFromOldSchoolPath({ area }: { area: AppArea }) {
	const { schoolSK } = useParams()
	return <Navigate to={GetHomePath(area, schoolSK)} replace />
}

function Routing() {

	return (
		<>
			<div className="PagesContainers">
				<Routes>
					<Route path="/*" element={<LandingPage />} />
					<Route path="/superadmin/*" element={
						<ProtectedRoute><AdministratorPage /></ProtectedRoute>
					} />
					<Route path="/admin/school/:schoolSK/*" element={
						<ProtectedRoute><SchoolAdministratorPage /></ProtectedRoute>
					} />
					<Route path="/school/:schoolSK/*" element={
						<ProtectedRoute><UserPage /></ProtectedRoute>
					} />
					<Route path="/login" element={<LoginPage />} />
					<Route path="/admin" element={<Navigate to={GetHomePath('superAdmin')} replace />} />
					<Route path="/admin/colegio/:schoolSK/*" element={<RedirectFromOldSchoolPath area="schoolAdmin" />} />
					<Route path="/colegio/:schoolSK/*" element={<RedirectFromOldSchoolPath area="school" />} />
				</Routes>
			</div>
		</>
	)
}

export default Routing;
